import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'abbreviation',
    standalone: false
})
export class AbbreviationPipe implements PipeTransform {

	transform(value: any, args?: any): any {
		let abbreviation = '';
		let words = value.split(' ');
		if (words.length >= 2) {
			abbreviation += words[0].substring(0, 1);
			abbreviation += words[1].substring(0, 1);
		} else {
			abbreviation += words[0].substring(0, 2);
		}
		return abbreviation.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); //Quita tildes,
	}

}
